var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgRefreshRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 29c6.075 0 11-4.925 11-11h2c0 7.18-5.82 13-13 13S3 25.18 3 18 8.82 5 16 5a12.99 12.99 0 0111 6.068V5h2v9h-9v-2h5.222A10.992 10.992 0 0016 7C9.925 7 5 11.925 5 18s4.925 11 11 11z"
  })));
}

export default __webpack_public_path__ + "e6f4f7f4a0351c2c04f2fb2fe4f5f92f.svg";
export { SvgRefreshRight as ReactComponent };